"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializeReadHelper = void 0;
// com.erostek.eroslink.SerializeReadHelper
// ObjectInputStream wrapper that computes a CRC32 of all data read.
class SerializeReadHelper {
    constructor(stream) {
        this.stream = stream;
    }
    readStringObject() {
        const obj = this.stream.readObject();
        if (obj === null) {
            return null;
        }
        if (typeof obj !== "string") {
            throw new Error("expected string");
        }
        return obj;
    }
    readObject() {
        return this.stream.readObject();
    }
    readBoolean() {
        return this.stream.readBoolean();
    }
    readByte() {
        return this.stream.readByte();
    }
    readDouble() {
        return this.stream.readDouble();
    }
    readFloat() {
        return this.stream.readFloat();
    }
    readInt() {
        return this.stream.readInt();
    }
    readLong() {
        return this.stream.readLong();
    }
    readShort() {
        return this.stream.readShort();
    }
    isReadAndCheckCrcOk() {
        const crc32 = this.stream.readLong();
        return true; // TODO
    }
}
exports.SerializeReadHelper = SerializeReadHelper;
